import { createRootRouteWithContext, Outlet, useNavigate, useRouterState } from '@tanstack/react-router'
import { useEffect, type ReactNode } from 'react'
import Spinner from '@tandem/ui/Spinner'
import Layout from '@/layouts/Main'
import SplashLayout from '@/layouts/Splash'
import Devtools from '@/Devtools'
import { useAuth } from '@/auth/AuthContext'

export interface RouterContext {
  auth: {
    isAuthenticated: boolean
    isLoading: boolean
  }
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  let { isAuthenticated, isLoading, company } = useAuth()
  let navigate = useNavigate()
  let pathname = useRouterState({ select: (s) => s.location.pathname })

  let isPublicRoute = pathname === '/login'

  useEffect(() => {
    if (!isPublicRoute && !isAuthenticated && !isLoading) {
      navigate({ to: '/login', search: { token: undefined } })
    }
  }, [isAuthenticated, isLoading, isPublicRoute, navigate])

  let content: ReactNode
  if (!isPublicRoute && !isAuthenticated) {
    content = (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <Spinner />
      </div>
    )
  } else if (isPublicRoute) {
    content = <Outlet />
  } else if (!isLoading && !company) {
    content = (
      <SplashLayout>
        <h2>За дело!</h2>
      </SplashLayout>
    )
  } else {
    content = (
      <Layout>
        <Outlet />
      </Layout>
    )
  }

  return (
    <>
      {content}
      {import.meta.env.DEV && <Devtools />}
    </>
  )
}
